export default "__VITE_ASSET__BYO0tiUh__"